"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.EMPTY_DATA = exports.CARDS_GRID = exports.LIST_CONTAINER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var LIST_CONTAINER = function LIST_CONTAINER(a) {
  var b = a.loading,
      c = a.isMobile;
  return (0, _cxs["default"])(_objectSpread({
    height: "100%",
    flex: b ? 1 : "initial"
  }, c ? {
    " .list-container__content__item > .check-box": {
      height: "20px",
      minHeight: "20px",
      minWidth: "20px",
      width: "20px",
      marginRight: "10px"
    }
  } : {}));
};

exports.LIST_CONTAINER = LIST_CONTAINER;

var CARDS_GRID = function CARDS_GRID(a) {
  var b = a.isMobile;
  return (0, _cxs["default"])({
    display: "grid",
    justifyContent: b ? "center" : "flex-start",
    gridColumnGap: "20px",
    gridRowGap: "20px",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gridAutoRows: "minmax(250px, max-content)"
  });
};

exports.CARDS_GRID = CARDS_GRID;
var EMPTY_DATA = (0, _cxs["default"])({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
});
exports.EMPTY_DATA = EMPTY_DATA;